import { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { userService } from "../services/user"
import { setUpperPopup, setCallbackLink } from "../store/reducers/general"
import { ErrorPage } from "../pages/error"
import { login } from "../store/reducers/user"
const slots = [0, 1, 2, 3, 4, 5]

export function Login() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { callbackLink } = useSelector(state => state.general)
    const [email, setEmail] = useState(null)
    const [code, setCode] = useState({
        0: '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
    })
    const emailRef = useRef()

    useEffect(() => {
        if (Object.values(code).every(val => val !== '')) submitCode(false)
    }, [code])

    const handleEmail = async (ev) => {
        if (ev) ev.preventDefault()
        try {
            await userService.sendOTP(emailRef.current.value)
            setEmail(emailRef.current.value)
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const submitCode = async (ev) => {
        try {
            if (ev) ev.preventDefault()
            const formatted = code[0] + code[1] + code[2] + code[3] + code[4] + code[5]
            const user = await userService.validateOTP(email, formatted)
            if (!user) return dispatch(setUpperPopup('errorOTP'))
            dispatch(login(user))
            if (!callbackLink) navigate('/')
            else {
                const link = callbackLink
                dispatch(setCallbackLink(''))
                navigate(link)
            }
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const handleCode = (ev) => {
        const { value, name } = ev.target

        if (value && value.length === 6) {
            setCode({ 0: value[0], 1: value[1], 2: value[2], 3: value[3], 4: value[4], 5: value[5] })
            document.getElementById(5).focus()
            return
        }

        for (let i = 0; i < Number(name); i++) if (code[i] === '') {
            document.getElementById(i).focus()
            return
        }

        if ((Number(value) >= 0 && Number(value) <= 9)) {
            if (value !== '' && name !== '5') document.getElementById(Number(name) + 1).focus()
            setCode({ ...code, [name]: value })
        }
    }

    const onDelete = (ev) => {
        const { key, target } = ev
        if (key === 'Backspace' && target.value === '' && target.name !== '0') document.getElementById(Number(target.name) - 1).focus()
    }

    try {
        return <section className="login">
            <div className="inner">
                <h1>התחברות</h1>
                {!email && <form onSubmit={handleEmail}>
                    <h2>אנא הזן אימייל :</h2>
                    <input type='email' className="phone" ref={emailRef} placeholder='example@gmail.com' required autoComplete="email" />
                    <p>קוד בעל 6 ספרות ישלח לאימייל שהזנת.</p>
                    <button>המשך</button>
                </form>}

                {email && <>
                    <h2>אנא הזן את הקוד שקיבלת למייל {email} :</h2>
                    <form onSubmit={submitCode}>
                        <div className="code">
                            {slots.map(num => <input key={num} autoFocus={num === 0 ? true : false} id={num} type="number" name={num} required className="digit" value={code[num]} onChange={handleCode} onKeyDown={onDelete} />)}
                        </div>
                        <p className="clickable underline" onClick={() => { setEmail(null); setCode({ 0: '', 1: '', 2: '', 3: '', 4: '', 5: '' }) }}>לא המייל שלך?</p>
                        <button onClick={submitCode}>התחבר</button>
                    </form>
                </>}
            </div>
        </section>
    }
    catch {
        return <ErrorPage />
    }
}